import TicketsController from './tickets.controller';

export default {
    template: require('./tickets.tpl.html'),
    controller: TicketsController
};
